import React from 'react'
import { BottleneckMessage } from '../domain/BottleneckMessage'
import { ServerRenderedDescription } from '../ui/server-rendered-description'

type Props = {
    message: BottleneckMessage
}

export const BottleneckDescription: React.FunctionComponent<Props> = ({ message }) => (
    <ServerRenderedDescription html={message.description} />
)
